import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "ar";
  const next = current === "ar" ? "en" : "ar";
  const label = next === "en" ? "EN" : "ع";
  return (
    <button
      type="button"
      onClick={() => i18n.changeLanguage(next)}
      aria-label={t("common.language")}
      title={next === "en" ? t("common.english") : t("common.arabic")}
      className={cn(
        "grid h-9 w-9 place-items-center rounded-lg border border-line/20 text-[11px] font-extrabold text-ink-2 transition-all hover:scale-105 hover:bg-canvas focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
        className,
      )}
    >
      <span className={next === "en" ? "num" : ""}>{label}</span>
    </button>
  );
}
